// Sidebar del portal Collections (Cobrador) — fuente: mockup portal-cobrador.html.
import { linkOptions } from '@tanstack/react-router';
import {
    Calendar,
    ClipboardCheck,
    HandCoins,
    Handshake,
    Home,
    LineChart,
    Users,
} from 'lucide-react';
import type { AppShellNavGroup } from '@/shared/patterns/AppShell';

export const COLLECTIONS_PORTAL_TITLE = 'Portal Cobrador';

const section = (slug: string) =>
    linkOptions({ to: '/collections/$section', params: { section: slug } });

export const collectionsNav: AppShellNavGroup[] = [
    {
        items: [
            { label: 'Home', icon: Home, link: linkOptions({ to: '/collections' }), exact: true },
        ],
    },
    {
        label: 'Mi turno',
        items: [
            {
                slug: 'agenda',
                label: 'Agenda',
                pageTitle: 'Agenda del día',
                icon: Calendar,
                link: linkOptions({ to: '/collections/agenda' }),
                status: 'mock',
            },
            {
                slug: 'promises',
                label: 'Compromisos',
                icon: Handshake,
                link: linkOptions({ to: '/collections/promises' }),
                status: 'mock',
            },
            {
                slug: 'payments',
                label: 'Pagos',
                pageTitle: 'Pagos recibidos',
                icon: HandCoins,
                link: linkOptions({ to: '/collections/payments' }),
                status: 'mock',
            },
            {
                slug: 'customers',
                label: 'Clientes',
                pageTitle: 'Mis clientes',
                icon: Users,
                link: linkOptions({ to: '/collections/customers' }),
                status: 'mock',
            },
            {
                slug: 'shift-close',
                label: 'Cierre del turno',
                icon: ClipboardCheck,
                link: section('shift-close'),
            },
            {
                slug: 'team-portfolio',
                label: 'Cartera equipo',
                icon: LineChart,
                link: section('team-portfolio'),
            },
        ],
    },
];
